<template>
    <div v-bind:class="[{ busy: loadingCart }]" class="article-dropdown-container opacity-transition">
        <pb-spinner v-if="loadingCart"/>
        <div class="inner" v-else-if="itemCount > 0">
            <cart :key="key" v-for="(cart,key) in cartArray" :cart="cart"/>
        </div>
        <div v-else class="py-3 text-center">
            Cart is empty
        </div>
    </div>
</template>
<script>

    import {mapGetters, mapState} from "vuex";
    import Cart from "./Cart";

    export default {
        name: 'cart-dropdown',
        components: {
            'cart': Cart
        },
        computed: {
            ...mapState('cart', ['loadingCart']),
            ...mapGetters('cart', ['cartArray', 'itemArray', 'itemCount'])
        }
    }
</script>